import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// Components
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer';
import Notification from '../Notification/Notification';

// Hooks
import { useAppSelector } from '../../store';
import { useQueryParams } from '../../hooks/useQueryParams';

// Styles
import styles from './Layout.module.scss';

const Layout = () => {
  const isNotificationShown = useAppSelector(s => s.main.notification.isShown);
  const location = useLocation();
  const { setParam, getParam } = useQueryParams();

  const refCode = useRef(getParam('ref'));

  useEffect(() => {
    if (!getParam('ref') && refCode.current) {
      setParam('ref', refCode.current);
    }
  }, [location]);

  return (
    <div className={styles.layoutContainer}>
      <Header />
      <Outlet />
      <Footer />
      {isNotificationShown && <Notification />}
    </div>
  );
};

export default Layout;
